import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('LINKIT: Supabase connection pending... Check Vercel environment variables.');
}

export const supabase = createClient(
  supabaseUrl || 'https://linkit-placeholder.supabase.co',
  supabaseAnonKey || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...'
);

// CRITICAL: Restoring missing export for build stability
export const fetchAllUsernames = async (excludeProfileId = null) => {
  const profileQuery = supabase.from('profiles').select('username');
  let reservedQuery = supabase.from('username_reservations').select('username');
  
  if (excludeProfileId) {
    profileQuery.neq('id', excludeProfileId);
    reservedQuery = reservedQuery.neq('profile_id', excludeProfileId);
  }

  const [{ data: activeUsers, error: err1 }, { data: reserved, error: err2 }] = await Promise.all([
    profileQuery,
    reservedQuery
  ]);
  
  if (err1) console.error('Error fetching usernames:', err1.message);
  if (err2) console.error('Error fetching reservations:', err2.message);
  
  const activeNames = activeUsers ? activeUsers.map(p => p.username) : [];
  const reservedNames = reserved ? reserved.map(r => r.username) : [];

  return [...new Set([...activeNames, ...reservedNames])];
};

// Helper for Auth State
export const getSafeSession = async () => {
  const { data: { session }, error } = await supabase.auth.getSession();
  if (error) return null;
  return session;
};

export const clearSupabaseAuthStorage = () => {
  if (typeof window === 'undefined') return;

  const storageKeys = [];
  const collectKeys = (storage) => {
    if (!storage) return;
    for (let index = 0; index < storage.length; index += 1) {
      const key = storage.key(index);
      if (key) storageKeys.push({ storage, key });
    }
  };

  collectKeys(window.localStorage);
  collectKeys(window.sessionStorage);

  storageKeys.forEach(({ storage, key }) => {
    const normalized = key.toLowerCase();
    if (
      normalized.startsWith('sb-') ||
      normalized.includes('supabase') ||
      normalized === '_linkit_shadow_routing_active'
    ) {
      storage.removeItem(key);
    }
  });
};
